import { clone } from '../utils'
import * as evaluationFunctions from './evaluationFunctions';

export function mergeFieldValueAndFieldType(blocValues, blocTypes, blocId, blocType, fieldType) {

    let bloc = blocValues.find((b) => b.mobile_id === blocId);
    let fieldsValue = bloc.field_ids;

    if (fieldType) {
        let blocTypeId = fieldType.block_type_id;
        if (!blocTypeId && fieldType.parent_id) {
            blocTypeId = bloc.type_id;
            let fieldValue = fieldsValue.find((f) => f.type_id === fieldType.parent_id)
            let childrenFieldsValue = fieldValue.value_field_ids;
            return mergeComplexeFieldValueAndFieldType(childrenFieldsValue, blocTypes, fieldType.parent_id, blocTypeId)
        }

        if (!blocType)
            blocType = blocTypes.find((bt) => bt.id === blocTypeId)
    }

    let fieldTypes = blocType.field_ids;

    let fields = [];
    fieldsValue.forEach((fv) => {
        fieldTypes.forEach((ft) => {
            if (fv.type_id === ft.id) {
                let field = Object.assign(clone(fv), clone(ft));
                fields.push(field);
            }
        })
    })

    return fields;
}

export function mergeComplexeFieldValueAndFieldType(fieldsValue, blocTypes, modelParentId, blocTypeId) {
    let blocType = blocTypes.find((bt) => bt.id === blocTypeId)
    let fieldType = blocType.field_ids.find(f => f.id === modelParentId)

    let fields = [];
    fieldsValue.forEach((fv) => {
        let id = fv.id
        let field = Object.assign(fv, fieldType);
        field.master_type_id = fieldType.id;
        field.id = id;
        fields.push(field);
    })

    return fields;
}

export function evaluateDynamicPropertyOfField(fields, model, dynamicPropertyName, defaultValue, stateAccessor){
    let field;
    let fieldTypeId = model.id;

    if (model.parent_id) {
        fieldTypeId = model.parent_id;
        let fieldMaster = fields.find((f) => f.master_type_id === fieldTypeId);
        field = fieldMaster.field_type_ids.find((f) => f.id === model.id);
    } else {
        field = fields.find((f) => f.type_id === fieldTypeId);
    }

    if (!field)
        return "Impossible de vérifier l'évaluation de la propriété " + dynamicPropertyName + " sur le champ " + fieldTypeId + " car il est introuvable";

    if (!field[dynamicPropertyName])
        return defaultValue;

    return evaluateDynamicProperty(fields, field, dynamicPropertyName, stateAccessor);
}

export function evaluateDynamicPropertyOfBloc(fields, model, dynamicPropertyName, defaultValue, stateAccessor){
    if (!model[dynamicPropertyName])
        return defaultValue;

    return evaluateDynamicProperty(fields, model, dynamicPropertyName, stateAccessor);
}

export function evaluateDynamicProperty(fields, fieldOrBloc, dynamicPropertyName, stateAccessor) {

    let fieldsCodesNeeded = getFromBetween.get(fieldOrBloc[dynamicPropertyName], "{{", "}}");
    let fieldsValuesNeeded = [];
    let fieldMissing = false;
    fieldsCodesNeeded.forEach((fcn) => {
        let field = fields.find((f) => f.code === fcn)

        if (fcn === "evaluationFunctions")
            fieldsValuesNeeded.push(evaluationFunctions);
        else if(fcn === "stateAccessor"){
            fieldsValuesNeeded.push(stateAccessor);
        } else {
            if (!field)
                fieldMissing = fcn;

            fieldsValuesNeeded.push(field)
        }
    });

    if (fieldMissing)
        return "Impossible de vérifier l'évaluation de la propriété " + dynamicPropertyName + " sur le champ ou le bloc " + fieldOrBloc.id + " car le code [" + fieldMissing + "] spécifié dans l'évaluation est introuvable"

    let regexCurlyBracketStart = /{{/g;
    let regexCurlyBracketEnd = /}}/g;

    let transformedStringEvaluation = fieldOrBloc[dynamicPropertyName].replace(regexCurlyBracketStart, "").replace(regexCurlyBracketEnd, "");
    //fieldsCodesNeeded => Codes des champs à remplacer
    //transformedStringEvaluation => Evaluation où les doubles accolades ont été remplacées
    let evaluator = new Function(fieldsCodesNeeded, transformedStringEvaluation);// eslint-disable-line
    //Exécute l'évaluation en remplaçant les codes par les valeurs de fieldsValuesNeeded
    try {
        return evaluator(...fieldsValuesNeeded);
    } catch (error) {
        console.error(error);
        return "Impossible de vérifier l'évaluation de la propriété " + dynamicPropertyName + " sur le champ ou le bloc " + fieldOrBloc.id;
    }
}

export function checkDynamicPropertyOfField(fields, model, dynamicPropertyName, defaultValue, stateAccessor) {

    let evaluationResult = evaluateDynamicPropertyOfField(fields, model, dynamicPropertyName, defaultValue, stateAccessor);

    if (typeof evaluationResult !== "boolean" && typeof evaluationResult !== "string")
        return "L'évaluation retournée n'est ni un booléen ni une chaine de caractère. Veuillez vérifier le paramétrage";

    return evaluationResult;
}

var getFromBetween = {
    results: [],
    string: "",
    getFromBetween: function (sub1, sub2) {
        if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
        var SP = this.string.indexOf(sub1) + sub1.length;
        var string1 = this.string.substr(0, SP);
        var string2 = this.string.substr(SP);
        var TP = string1.length + string2.indexOf(sub2);
        return this.string.substring(SP, TP);
    },
    removeFromBetween: function (sub1, sub2) {
        if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
        var removal = sub1 + this.getFromBetween(sub1, sub2) + sub2;
        this.string = this.string.replace(removal, "");
    },
    getAllResults: function (sub1, sub2) {
        // first check to see if we do have both substrings
        if (this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return;

        // find one result
        var result = this.getFromBetween(sub1, sub2);
        // push it to the results array
        this.results.push(result);
        // remove the most recently found one from the string
        this.removeFromBetween(sub1, sub2);

        // if there's more substrings
        if (this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
            this.getAllResults(sub1, sub2);
        }
        else return;
    },
    get: function (string, sub1, sub2) {
        this.results = [];
        this.string = string;
        this.getAllResults(sub1, sub2);
        return this.results;
    }
};

export function getStateAccessor(props) {

    let stateAccessor = {}

    if (!props) {
        console.warn("Attention, l'accessor n'a pu être généré correctement")
        return stateAccessor;
    }

    stateAccessor.loggedEmployee = props.loggedEmployee;
    stateAccessor.fluidBottles = props.fluidBottles;
    stateAccessor.intervention = props.intervention;
    stateAccessor.sppFound = props.sppFound;
    return stateAccessor;
}

/**** exemple avec somme de plusieurs champs
const fake_fields = [
    {
        code: "QUANTITE_PREVI",
        stringEvaluation: "return true;",
        value: 60,
    },
    {
        code: "QUANTITE_REEL",
        stringEvaluation: "return {{QUANTITE_PREVI}}.value === {{QUANTITE_REEL}}.children.map((c) => c.value).reduce((sum, currentValue) => sum + currentValue)",
        value: 6,
        children: [
            {
                code: "QUANTITE_PREVI",
                stringEvaluation: "return true;",
                value: 54,
            },
            {
                code: "QUANTITE_PREVI",
                stringEvaluation: "return true;",
                value: 6,
            }
        ]
    }
]
*/
